import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer
      className="footer position-relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f1f3f4 100%)',
        color: '#495057'
      }}
    >
      {/* Decorative background elements */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: 'radial-gradient(circle at 20% 80%, rgba(66, 89, 168, 0.08) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(66, 89, 168, 0.08) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}
      ></div>

      {/* Main footer content */}
      <motion.div 
        className="container py-5 position-relative"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <div className="row justify-content-center text-center text-lg-start">
          
          {/* Address Section */}
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                   style={{width: '40px', height: '40px', backgroundColor: '#4259A8'}}>
                <i className="fas fa-map-marker-alt text-white"></i>
              </div>
              <h5 className="mb-0 fw-bold" style={{color: '#4259A8'}}>Adresa i sjedište</h5>
            </div>
            <div className="ps-0 ps-lg-5 ms-0 ms-lg-2">
              <p className="mb-2" style={{color: '#495057'}}>POLIKLINIKA AKRION d.o.o.</p>
              <p className="mb-2" style={{color: '#495057'}}>Rudarska 8</p>
              <p className="mb-0" style={{color: '#495057'}}>52220 Labin, Hrvatska</p>
            </div>
          </div>

          {/* Working Hours Section */}
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                   style={{width: '40px', height: '40px', backgroundColor: '#4259A8'}}>
                <i className="fas fa-clock text-white"></i>
              </div>
              <h5 className="mb-0 fw-bold" style={{color: '#4259A8'}}>Radno vrijeme</h5>
            </div>
            <div className="ps-0 ps-lg-5 ms-0 ms-lg-2">
              <p className="mb-2" style={{color: '#495057'}}>Ponedjeljak – Petak: 09:00 – 20:00</p>
              <p className="mb-0" style={{color: '#495057'}}>Subota i nedjelja: po dogovoru</p>
            </div>
          </div>

          {/* Contact & Social Section */}
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                   style={{width: '40px', height: '40px', backgroundColor: '#4259A8'}}>
                <i className="fas fa-share-alt text-white"></i>
              </div>
              <h5 className="mb-0 fw-bold" style={{color: '#4259A8'}}>Društvene mreže</h5>
            </div>
            <div className="ps-0 ps-lg-5 ms-0 ms-lg-2">
              <div className="d-flex justify-content-center justify-content-lg-start">
                <a
                  className="btn btn-outline-primary btn-social mx-1 rounded-circle d-flex align-items-center justify-content-center"
                  href="https://www.facebook.com/profile.php?id=61582566025649"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '45px', 
                    height: '45px',
                    transition: 'all 0.3s ease',
                    border: '2px solid #4259A8',
                    backgroundColor: 'transparent',
                    color: '#4259A8'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 5px 15px rgba(59, 89, 152, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-outline-primary btn-social mx-1 rounded-circle d-flex align-items-center justify-content-center"
                  href="https://www.instagram.com/_akrion_/?hl=en"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '45px', 
                    height: '45px',
                    transition: 'all 0.3s ease',
                    border: '2px solid #4259A8',
                    backgroundColor: 'transparent',
                    color: '#4259A8'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 5px 15px rgba(0, 119, 181, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Bottom bar */}
      <div 
        className="border-top position-relative"
        style={{borderColor: 'rgba(66, 89, 168, 0.2) !important'}}
      >
        <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-3 mb-lg-0 text-center text-lg-start">
                  <Link to="/politika-privatnosti" className="text-decoration-none me-4"
                   style={{
                  transition: 'color 0.3s ease',
                  color: '#6c757d'
                }}
                onMouseEnter={(e) => e.target.style.color = '#4259A8'}
                onMouseLeave={(e) => e.target.style.color = '#6c757d'}>
                 Politika privatnosti
               </Link>

             <Link to="/kolacici" className="text-decoration-none me-4"
                   style={{
                  transition: 'color 0.3s ease',
                  color: '#6c757d'
                }}
                onMouseEnter={(e) => e.target.style.color = '#4259A8'}
                onMouseLeave={(e) => e.target.style.color = '#6c757d'}>
                 Postavke kolačića
               </Link>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <p className="mb-0" style={{color: '#6c757d'}}>
                © 2025 Poliklinika Akrion. Sva prava pridržana.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;